module.exports = __webpack_public_path__ + "img/rules_5.c294cda8.png";